/** Canonical public origins for personal sites. */
export const siteUrls = Object.freeze({
  home: 'https://n3wth.com',
  ui: 'https://ui.n3wth.com',
  garden: 'https://garden.n3wth.com',
  skills: 'https://skills.n3wth.com',
  r3: 'https://r3.n3wth.com',
  kit: 'https://kit.n3wth.com',
  hop: 'https://hop.flights',
  lunch: 'https://lunchmoney.sh',
})
